import Vue from 'vue'
import Router from 'vue-router'
import {DefaultRouter} from '@/config/router.config'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: DefaultRouter
})
